import { BaseAction } from "../../../core/actions/BaseAction";
import { getCmsStopImageByStopId } from "../../../Lib/Utils/validationUtil";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { IDepartureFromTrips, IGetDepartureFromListByStationActionProps } from "../../../Orchestrator/Types/Interface/IDepartureFromTrips";
import { getFavouriteDeparturesBestPrices } from "../../../app/api/getFavouriteDeparturesBestPrices";
import {
    IBestPricePriceItem,
    IFavouriteDeparturesBestPricesResponse,
} from "../../../Orchestrator/Types/Interface/IFavouriteDeparturesBestPrices";

class GetDepartureFromListByStationAction extends BaseAction<void, IGetDepartureFromListByStationActionProps> {
    override async run(): Promise<void> {
        try {
            const { fromStationCode, StationLists } = this.params!;
            if (!StationLists || StationLists.length === 0) {
                updateRecoilState("departureFromTripsAtom", []);
                return;
            }

            const response: any = await getFavouriteDeparturesBestPrices(false);
            const payload: IFavouriteDeparturesBestPricesResponse | undefined =
                response?.status === "ok" ? response.answer : undefined;

            const stationNameById = new Map<string, string>(
                (payload?.stations || []).map((s) => [s.id, s.name]),
            );
            const stationListNameById = new Map<string, string>(
                StationLists.map((s) => [s.id, s.name]),
            );
            const resolveName = (id: string) =>
                stationNameById.get(id) ?? stationListNameById.get(id) ?? id;

            const lowestByDestination = new Map<string, IBestPricePriceItem>();
            for (const p of payload?.prices || []) {
                if (p.origin !== fromStationCode) continue;
                if (p.destination === fromStationCode) continue;
                const existing = lowestByDestination.get(p.destination);
                if (!existing || p.price < existing.price) {
                    lowestByDestination.set(p.destination, p);
                }
            }

            const departureFromTrips: IDepartureFromTrips[] = [];
            for (const [destination, lowest] of lowestByDestination) {
                departureFromTrips.push({
                    imgSrc: getCmsStopImageByStopId(destination) || "/images/SliderImage1.jpg",
                    from: resolveName(fromStationCode),
                    to: resolveName(destination),
                    price: String(lowest.price),
                    fromCode: fromStationCode,
                    toCode: destination,
                    date: lowest.date,
                });
            }

            updateRecoilState("departureFromTripsAtom", departureFromTrips);
        } catch (error: any) {
            console.error("Error in GetDepartureFromListByStationAction:", error);
        }
    }
}

export const getDepartureFromListByStationAction = new GetDepartureFromListByStationAction();
